/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import VueHead from "vue-head";
import Config from "@/conf/Config.js";
Vue.use(VueHead);
Vue.use(Router);

const router = new Router({
    // mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            props: true,
            component: () => import("./views/Home.vue")
        },
		{
		    path: "/qrcode",
		    name: "Qrcode",
		    props: true,
		    component: () => import("./views/QrCodeReader.vue")
		},
		{
		    path: "/upload",
		    name: "Upload",
		    props: true,
		    component: () => import("./views/UploadFile.vue")
		}
    ]
});

router.beforeEach((to, from, next) => {
    try {
        if (to.matched.some(record => record.meta.auth)) {
            axios.defaults.baseURL = Config.apiUrl;
            axios.defaults.headers.common["authorization"] = localStorage.brantastoken;
            axios.post("/tproject/admin/checklogin").then(function (response) {
                if (response.data.success == true) {
                    try {
                        next();
                    } catch (err) {
                        next("/login");
                    }
                } else {
                    next("/login");
                }
            });
        } else {
            if (to.matched.length > 0){
                if (to.matched[0].name == "Login") {
                    axios.defaults.baseURL = Config.apiUrl;
                    axios.defaults.headers.common["authorization"] = localStorage.brantastoken;
                    axios.post("/tproject/admin/checklogin").then(function (response) {
                        if (response.data.success == true) {
                            console.log(localStorage.admin);
                            try {
                                next();
                            } catch (err) {
                                next("/login");
                            }
                        } else {
                            next("/login");
                        }
                    });
                }else if (to.matched[0].name == "Loginpelamar") {
                    axios.defaults.baseURL = Config.apiUrl;
                    axios.defaults.headers.common["authorization"] = localStorage.brantastoken;
                    axios.post("/tproject/admin/checklogin").then(function (response) {
                        if (response.data.success == true) {
                            console.log(localStorage.admin);
                            try {
                                next();
                            } catch (err) {
                                next("/loginpelamar");
                            }
                        } else {
                            next("/loginpelamar");
                        }
                    });
                }else{
                    console.log(localStorage.admin);
                }
            }
            next();
            // if (to.matched.length > 0) {
            //     next();
            // } else {
            //     next("/admin");
            // }
        }
    } catch (error) {
        console.log("router error1", error);
    }
});

router.beforeResolve((to, from, next) => {
    // If this isn"t an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start();
    }
    next()
});


router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    NProgress.done()
});

export default router;
